import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ANALYTICS_URI } from '@cores/constants/envConfig';
let ExportApiImpl = class ExportApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${ANALYTICS_URI}/core-basic-api`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getExportQueryIdApi(params) {
        return await this.post({
            url: '/analytics/patents/export',
            method: 'POST',
            data: params,
            transformCode: true,
        }).then(({ data }) => {
            return data;
        });
    }
};
ExportApiImpl = __decorate([
    injectable()
], ExportApiImpl);
export { ExportApiImpl };
